export const iconCss = {
  path: {
    fill: "currentColor",
    stroke: "transparent !important",
  },
};
